/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailAccess } from './EmailAccess';
import {
    EmailAccessFromJSON,
    EmailAccessFromJSONTyped,
    EmailAccessToJSON,
} from './EmailAccess';

/**
 * 
 * @export
 * @interface EmailAccessResponse
 */
export interface EmailAccessResponse {
    /**
     * 
     * @type {EmailAccess}
     * @memberof EmailAccessResponse
     */
    data?: EmailAccess;
}

/**
 * Check if a given object implements the EmailAccessResponse interface.
 */
export function instanceOfEmailAccessResponse(value: object): value is EmailAccessResponse {
    let isInstance = true;

    return isInstance;
}

export function EmailAccessResponseFromJSON(json: any): EmailAccessResponse {
    return EmailAccessResponseFromJSONTyped(json, false);
}

export function EmailAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailAccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : EmailAccessFromJSON(json['data']),
    };
}

export function EmailAccessResponseToJSON(value?: EmailAccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': EmailAccessToJSON(value.data),
    };
}

